import { render, staticRenderFns } from "./IconFeatures.vue?vue&type=template&id=39c8fd4a&scoped=true&"
import script from "./IconFeatures.vue?vue&type=script&lang=js&"
export * from "./IconFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c8fd4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39c8fd4a')) {
      api.createRecord('39c8fd4a', component.options)
    } else {
      api.reload('39c8fd4a', component.options)
    }
    module.hot.accept("./IconFeatures.vue?vue&type=template&id=39c8fd4a&scoped=true&", function () {
      api.rerender('39c8fd4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconFeatures.vue"
export default component.exports